/** Workspace-wide rank between two neighbors (Linear / Jira style). */
export function midpointRank(prev: number | null, next: number | null): number {
  const STEP = 1000;
  if (prev === null && next === null) return 0;
  if (prev === null) return (next ?? 0) - STEP;
  if (next === null) return prev + STEP;
  if (next - prev > 1) return Math.floor((prev + next) / 2);
  return prev + 1;
}
